import React, { useState, useEffect, useCallback } from 'react';
import ProfileImageWithFullscreen from '../../Components/Onbaording/profile-image-with-fullscreen';
import { useToast } from '../../Utils/toastContext';
import { debounce } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import DocumentPreview from '../Create-Investment/documentpreview';
import CommentInput from '../../Components/Onbaording/inputfield-withemojis';
import { useNavigate, useParams } from 'react-router-dom';
import {
  UpdateFieldStatusTrue,
  UpdateFieldStatusFalse,
} from '../../Redux/store/onboardingFormSlice';
import { formatDateTimeUTC } from '../../Constants/helper-functions';

const ReviewPopupKYC = ({
  isOpen,
  onClose,
  currentField,
  currentFieldName,
  currentFieldValue,
  currentFieldType,
}) => {
  const { showToast } = useToast();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.user.userId);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [activeTab, setActiveTab] = useState('comments');
  const [rejectReason, setRejectReason] = useState(null);
  const [comment, setComment] = useState('');
  const [currentDateTime, setCurrentDateTime] = useState('');
  const [loading, setLoading] = useState(false);
  const [currentDocument, setcurrentDocument] = useState({});
  const [rejectedBy, setRejectedBy] = useState('');
  const [rejectedByRole, setRejectedByRole] = useState('');
  const [rejectionTime, setRejectionTime] = useState('');
  const [rejectionDate, setRejectionDate] = useState('');
  const { customerId } = useParams();
  const [verificationConfirmed, setVerificationConfirmed] = useState(false);
  const loggedInUserRole = useSelector((state) => state.user.roleName);
  const fileIdsRedux = useSelector((state) => state.user.fileIdsRedux);
  const getInitials = (name) => {
    if (!name) return '?';
    return name.trim().charAt(0).toUpperCase();
  };

  const getAvatarStyle = (name) => {
    const styles = [
      'bg-[#EEF2FF] text-[#3730A3] ring-1 ring-[#E0E7FF]', // Indigo soft
      'bg-[#F1F5F9] text-[#334155] ring-1 ring-[#E2E8F0]', // Slate
      'bg-[#FDF2F8] text-[#9D174D] ring-1 ring-[#FBCFE8]', // Rose subtle
      'bg-[#F0FDF4] text-[#166534] ring-1 ring-[#BBF7D0]', // Green subtle
      'bg-[#FFFBEB] text-[#92400E] ring-1 ring-[#FDE68A]', // Amber subtle
    ];

    const index = name?.charCodeAt(0) % styles.length;
    return styles[index];
  };
  const handleRadioChange = (e) => {
    setSelectedOption(e.target.value);
    setActiveTab(e.target.value);
    // if (e.target.value == "approve") {
    //   setLoading(true);
    //   handlSendComment(e, "approve");
    // }
  };
  const handleFileClick = (docData) => {
    setcurrentDocument(docData);
    setIsModalOpen(true);
  };
  const [comments, setComments] = useState([]);
  const formatDateTime = (dateString) => {
    const [datePart, timePart, meridian] = dateString.split(' ');
    const [day, month, year] = datePart.split('/');
    const [hours, minutes] = timePart.split(':');

    // Convert 24-hour format to 12-hour format
    const hours12 = (+hours % 12 || 12).toString();
    const formattedTime = `${hours12}:${minutes}${meridian}`;
    return `${day}/${month}/${year} | ${formattedTime}`;
  };
  const addComment = async (action) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl =
      loggedInUserRole == 'agent'
        ? `${BASE_URL}/api/v1/agent/customers/review/${customerId}/verify-field`
        : `${BASE_URL}/api/v1/agency/customers/review/${customerId}/verify-field`;
    const bodyData = {
      verification_id: currentField.verification_id,
      action: action,
      comment: comment,
      file_ids: fileIdsRedux,
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handlSendComment = useCallback(
    debounce(async (e, action) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        dispatch(UpdateFieldStatusFalse());

        const response = await addComment(action);
        if (response.status == 200) {
          toastMessage = {
            message:
              action == 'approve'
                ? 'Approval completed successfully'
                : action == 'comment'
                  ? 'Comment added successfully'
                  : 'Request rejected successfully',
            type: 'success',
          };
          dispatch(UpdateFieldStatusTrue());
          onClose();
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (error) {
        setSelectedOption('');
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 1000); // Small delay if needed
        }
      }
    }, 1000),
    [currentField, comment, rejectReason, selectedOption, fileIdsRedux], // Dependencies
  );
  const cleanDateTime = (input) => {
    // The API returns an ISO-8601 UTC timestamp, for example:
    // "2026-09-18T01:43:48.379213Z". Parse it as a Date instead of
    // splitting on spaces (an ISO timestamp does not contain spaces).
    if (!input) {
      return { date: '-', time: '-' };
    }

    const date = new Date(input);
    if (Number.isNaN(date.getTime())) {
      return { date: '-', time: '-' };
    }

    const parts = new Intl.DateTimeFormat('en-AU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    }).formatToParts(date);

    const values = Object.fromEntries(
      parts.map(({ type, value }) => [type, value]),
    );

    return {
      date: `${values.day}/${values.month}/${values.year}`,
      time: `${values.hour}:${values.minute} ${values.dayPeriod.toUpperCase()}`,
    };
  };

  useEffect(() => {
    const updateDateTime = () => {
      const now = new Date();
      const formatted = now
        .toLocaleString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        })
        .replace(',', ' |')
        .toUpperCase(); // 🔥 ensures AM/PM is capital

      setCurrentDateTime(formatted);
    };

    updateDateTime(); // set immediately
    const interval = setInterval(updateDateTime, 60000); // update every minute

    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    setComments(currentField.comments);
    if (currentField.status == 'approved') {
      setSelectedOption('approve');
    }
    if (currentField.status == 'rejected') {
      setSelectedOption('reject');
      setRejectReason(currentField.rejection_comment);
      const { date, time } = cleanDateTime(currentField.rejection_timestamp);
      setRejectionDate(date);
      setRejectionTime(time);
      setRejectedBy(
        `${currentField.rejected_by.first_name}${
          currentField.rejected_by.last_name
            ? ` ${currentField.rejected_by.last_name}`
            : ''
        }`,
      );
      setRejectedByRole(currentField.rejected_by.role);
    }
  }, [currentField]);
  useEffect(() => {
    if (
      selectedOption == 'approve' &&
      activeTab === 'approve' &&
      verificationConfirmed
    ) {
      setComment('I have verified the details.');
    }
  }, [verificationConfirmed, activeTab, selectedOption]);
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      {/* Modal Container */}
      <div className="bg-white h-[90vh] w-[90vw] max-w-md md:max-w-lg rounded-lg shadow-lg overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between bg-[#F2F2F2] py-2 px-3 text-white">
          <h2 className="text-sm text-black">Review</h2>
          <button onClick={onClose}>
            <img src="/add.svg" alt="Close" className="w-10 h-10" />{' '}
          </button>
        </div>

        {/* User Details */}
        <div className="p-4 bg-[#3047EC] border-b">
          <div className="flex items-start gap-6">
            {/* Left Section - First Name */}
            <div className="flex-1 min-w-0">
              <h3 className="text-xs text-[#A9E5FF]">{currentFieldName}</h3>
              {currentFieldType == 'file' && (
                <>
                  {currentField && currentFieldValue && (
                    <div
                      onClick={(e) => {
                        e.preventDefault();
                        handleFileClick(currentFieldValue);
                      }}
                      className="w-60 cursor-pointer mt-2 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                    >
                      <div className="flex-col flex">
                        <span className="text-black text-xs underline">
                          {currentFieldValue.file_name}
                        </span>
                      </div>
                    </div>
                  )}
                </>
              )}
              {currentFieldType != 'file' && (
                <>
                  {(currentFieldName == 'Profile Picture' ||
                    currentFieldName == 'Photo Upload' ||
                    currentFieldName == 'Trust Logo' ||
                    currentFieldName == 'Company Logo') && (
                    <>
                      <ProfileImageWithFullscreen
                        imageUrl={currentFieldValue}
                      />
                    </>
                  )}

                  {currentFieldName != 'Profile Picture' &&
                    currentFieldName != 'Photo Upload' &&
                    currentFieldName != 'Trust Logo' &&
                    currentFieldName != 'Company Logo' && (
                      <p className="text-sm text-white font-medium break-words whitespace-normal  line-clamp-2">
                        {currentFieldValue}
                      </p>
                    )}
                </>
              )}
            </div>
            {/* Right Section - Radio Buttons */}
            <div className="flex flex-wrap gap-4 items-center">
              {/* Approve */}
              <label
                className={`flex items-center text-sm cursor-pointer transition-opacity hover:opacity-80`}
              >
                <input
                  type="radio"
                  name="signatory"
                  value="approve"
                  onChange={handleRadioChange}
                  checked={selectedOption === 'approve'}
                  className="peer hidden"
                />
                <span className="w-4 h-4 border-2 rounded-full flex items-center justify-center peer-checked:border-green-500 transition-all">
                  <div
                    className={`w-2 h-2 rounded-full ${
                      selectedOption === 'approve' ? 'bg-[#46DA55]' : ''
                    }`}
                  ></div>
                </span>
                <span
                  className={`ml-2 text-white transition-opacity opacity-100`}
                >
                  Approve
                </span>
              </label>

              {/* Reject */}
              <label
                className={`flex items-center text-sm cursor-pointer transition-opacity hover:opacity-80`}
              >
                <input
                  type="radio"
                  name="signatory"
                  value="reject"
                  onChange={handleRadioChange}
                  checked={selectedOption === 'reject'}
                  className="peer hidden"
                />
                <span className="w-4 h-4 border-2 rounded-full flex items-center justify-center peer-checked:border-red-500 transition-all">
                  <div
                    className={`w-2 h-2 rounded-full ${
                      selectedOption === 'reject' ? 'bg-[#FF5050]' : ''
                    }`}
                  ></div>
                </span>
                <span
                  className={`ml-2 text-white transition-opacity opacity-100`}
                >
                  Reject
                </span>
              </label>
            </div>
          </div>
        </div>
        {/* Comments Section */}
        <div className="p-4 bg-white">
          <div className="">
            <div className="flex border-b border-gray-200">
              {/* Comments Tab */}
              <button
                onClick={() => setActiveTab('comments')}
                className={`flex-1 text-sm font-semibold pb-2 ${
                  activeTab === 'comments'
                    ? 'text-black border-b-2 border-black'
                    : 'text-gray-500 hover:text-black'
                }`}
              >
                Comments ({currentField.comments.length})
              </button>

              {/* Reject Reason Tab */}
              {selectedOption == 'reject' && (
                <button
                  onClick={() => setActiveTab('reject')}
                  className={`flex-1 text-sm font-semibold pb-2 ${
                    activeTab === 'reject'
                      ? 'text-black border-b-2 border-black'
                      : 'text-gray-500 hover:text-black'
                  }`}
                >
                  Reject Reason
                </button>
              )}
              {selectedOption == 'approve' && (
                <button
                  onClick={() => setActiveTab('approve')}
                  className={`flex-1 text-sm font-semibold pb-2 ${
                    activeTab === 'approve'
                      ? 'text-black border-b-2 border-black'
                      : 'text-gray-500 hover:text-black'
                  }`}
                >
                  Verification
                </button>
              )}
            </div>
            {/* Tab Content */}
            <div className="mt-3">
              {activeTab === 'comments' && (
                <div className="flex flex-col h-[80vh] max-h-[650px] bg-gradient-to-b from-slate-50 to-white rounded-2xl border border-slate-200 overflow-hidden shadow-lg">
                  {/* Header */}
                  <div className="px-5 py-4 border-b bg-white flex items-center justify-between">
                    <div>
                      <h3 className="text-sm font-semibold text-gray-900">
                        Review Activity
                      </h3>
                      <p className="text-xs text-gray-500 mt-1">
                        Complete verification history and comments
                      </p>
                    </div>

                    <div
                      className="
      px-3 py-1.5
      rounded-full
      bg-blue-50
      text-blue-600
      text-xs
      font-medium
    "
                    >
                      {comments.length} Activities
                    </div>
                  </div>

                  {/* Timeline */}
                  <div className="flex-1 overflow-y-auto px-4 sm:px-6 py-5">
                    {comments.length === 0 ? (
                      <div
                        className="
        h-full
        flex
        flex-col
        items-center
        justify-center
        text-gray-400
      "
                      >
                        <div
                          className="
          w-14 h-14
          rounded-full
          bg-gray-100
          flex
          items-center
          justify-center
          text-2xl
        "
                        >
                          💬
                        </div>

                        <p className="mt-3 text-sm">No activity yet</p>
                      </div>
                    ) : (
                      <div className="h-[80vh] max-h-[650px] overflow-y-auto px-3 py-4 bg-[#f6f8fc] rounded-2xl">
                        <div className="space-y-4">
                          {comments.map((item, index) => {
                            const isMe = item.added_by?.id === userId;

                            const formatRole = (role) => {
                              if (!role) return '';
                              if (role === 'super_admin') return 'Admin';
                              return (
                                role.charAt(0).toUpperCase() + role.slice(1)
                              );
                            };

                            const actionConfig = {
                              approve: {
                                icon: '✓',
                                title: 'Approved',
                                bg: 'bg-emerald-50',
                                text: 'text-emerald-600',
                                border: 'border-emerald-200',
                              },
                              reject: {
                                icon: '✕',
                                title: 'Rejected',
                                bg: 'bg-rose-50',
                                text: 'text-rose-600',
                                border: 'border-rose-200',
                              },
                              comment: {
                                icon: '💬',
                                title: 'Comment',
                                bg: 'bg-sky-50',
                                text: 'text-sky-600',
                                border: 'border-sky-200',
                              },
                            };

                            const action =
                              actionConfig[item.action] || actionConfig.comment;

                            return (
                              <div
                                key={index}
                                className={`flex ${isMe ? 'justify-end' : 'justify-start'}`}
                              >
                                <div
                                  className={`flex gap-2 max-w-[85%] ${isMe ? 'flex-row-reverse' : ''}`}
                                >
                                  {/* Avatar */}

                                  {item.added_by?.profile_picture ? (
                                    <img
                                      src={item.added_by?.profile_picture}
                                      className="w-9 h-9 rounded-full object-cover border border-gray-200 shrink-0"
                                    />
                                  ) : (
                                    <div
                                      className={`w-10 h-10 flex items-center justify-center rounded-full font-semibold text-sm ${getAvatarStyle(
                                        item.added_by?.first_name,
                                      )}`}
                                    >
                                      {getInitials(item.added_by?.first_name)}
                                    </div>
                                  )}
                                  {/* Message Bubble */}
                                  <div
                                    className={`
          relative
          px-4
          py-3
          rounded-2xl
          shadow-sm
          transition
          hover:shadow-md
          ${
            isMe
              ? 'bg-[#eef2ff] text-gray-900 border border-indigo-100 rounded-br-sm'
              : 'bg-white text-gray-800 border border-gray-200 rounded-bl-sm'
          }
        `}
                                  >
                                    {/* Header */}
                                    <div className="flex items-start justify-between gap-3 mb-2">
                                      <div>
                                        <p className="text-sm font-semibold text-gray-900">
                                          {item.added_by?.first_name}{' '}
                                          {item.added_by?.last_name}
                                        </p>

                                        {/* Role */}
                                        <span
                                          className={`
                inline-block
                mt-1
                px-2.5
                py-0.5
                text-[10px]
                rounded-full
                font-medium
                ${
                  isMe
                    ? 'bg-indigo-100 text-indigo-600'
                    : 'bg-gray-100 text-gray-600'
                }
              `}
                                        >
                                          {formatRole(item.added_by?.role)}
                                        </span>
                                      </div>

                                      {/* STATUS BADGE (Improved) */}
                                      <div
                                        className={`
              flex items-center gap-1.5
              px-2.5
              py-1
              rounded-full
              text-[11px]
              font-semibold
              border
              ${action.bg}
              ${action.text}
              ${action.border}
              shadow-sm
              whitespace-nowrap
            `}
                                      >
                                        <span className="text-[12px]">
                                          {action.icon}
                                        </span>
                                        {action.title}
                                      </div>
                                    </div>

                                    {/* Message */}
                                    <p className="text-sm leading-relaxed text-gray-700 break-words">
                                      {item.comment || 'No comment provided'}
                                    </p>

                                    {/* Attachments */}
                                    {item.files?.length > 0 && (
                                      <div className="mt-3 space-y-2">
                                        {item.files.map((file) => (
                                          <button
                                            key={file.file_name}
                                            onClick={() =>
                                              handleFileClick(file)
                                            }
                                            className="
                    flex items-center gap-2
                    text-xs
                    text-indigo-600
                    hover:underline
                    hover:text-indigo-700
                    transition
                  "
                                          >
                                            📄 {file.file_name}
                                          </button>
                                        ))}
                                      </div>
                                    )}

                                    {/* Footer */}
                                    <div className="flex justify-between items-center mt-3">
                                      <span className="text-[10px] text-gray-400">
                                        {formatDateTimeUTC(item.timestamp)}
                                      </span>

                                      {/* subtle action indicator */}
                                      <span className="text-[10px] text-gray-300">
                                        {action.title}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Comment Input */}
                  <div
                    className="
    border-t
    bg-white
    p-4
  "
                  >
                    <CommentInput
                      comment={comment}
                      setComment={setComment}
                      handlSendComment={handlSendComment}
                      setLoading={setLoading}
                      component="admin"
                    />
                  </div>
                </div>
              )}
              {activeTab === 'reject' && (
                <div className="space-y-4 mt-3 h-full">
                  <div className="p-4 flex flex-col">
                    <div className="w-full">
                      <textarea
                        id="reject-reason"
                        rows="3"
                        value={rejectReason ? rejectReason : comment}
                        disabled={rejectReason != null}
                        onChange={(e) => setComment(e.target.value)}
                        className="w-full mt-2 p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                        placeholder="Add reason here..."
                      />

                      {/* Date + Buttons row */}
                      <div className="font-medium flex flex-col md:flex-row justify-between items-center mt-6 space-y-2 md:space-y-0">
                        {/* DateTime on the left */}
                        {rejectReason == null && (
                          <span className="text-sm text-[#9C9C9C]">
                            {currentDateTime}{' '}
                          </span>
                        )}
                        {rejectReason != null && (
                          <span className="text-sm text-gray-600">
                            Rejected by{' '}
                            <span className="font-semibold text-black">
                              {rejectedBy}
                            </span>{' '}
                            <span className="text-[#3047EC]">
                              (
                              {rejectedByRole === 'super_admin'
                                ? 'Super Admin'
                                : rejectedByRole}
                              )
                            </span>{' '}
                            on{' '}
                            <span className="text-[#3047EC] font-medium">
                              {rejectionDate}{' '}
                            </span>
                            at{' '}
                            <span className="text-[#3047EC] font-medium">
                              {rejectionTime}
                            </span>
                          </span>
                        )}

                        {/* Buttons on the right */}
                        {!rejectReason && (
                          <div className="flex space-x-3">
                            {/* <button className="px-6 py-2 rounded-lg bg-white border text-black">
                            Delete
                          </button> */}
                            <button
                              disabled={!comment}
                              onClick={(e) => {
                                if (!comment) {
                                  showToast(
                                    'Please specify the reason for rejection to proceed',
                                    'error',
                                  );
                                  return;
                                }
                                setLoading(true);
                                handlSendComment(e, 'reject');
                              }}
                              className={`
          w-full
          sm:w-auto

          px-8
          py-3

          rounded-xl

          text-sm
          font-semibold

          transition-all
          duration-200

          ${
            comment
              ? 'bg-gradient-to-r from-[#375AE7] to-[#5B7CFF] text-white shadow-md hover:shadow-lg hover:-translate-y-[1px]'
              : 'bg-gray-200 text-gray-400 cursor-not-allowed'
          }

        `}
                            >
                              Apply
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {activeTab === 'approve' && (
                <div className="mt-4 px-4 pb-4">
                  <div
                    className="
    bg-white 
    rounded-2xl 
    border border-gray-200 
    shadow-sm 
    p-5
    space-y-5
  "
                  >
                    {/* Verification Header */}
                    <div className="flex items-start gap-3">
                      <div
                        className="
        w-10 h-10 
        rounded-full 
        bg-green-100 
        flex items-center 
        justify-center
        shrink-0
      "
                      >
                        <svg
                          className="w-5 h-5 text-green-600"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      </div>

                      <div>
                        <h3
                          className="
          text-sm 
          font-semibold 
          text-gray-900
        "
                        >
                          Verification Confirmation
                        </h3>

                        <p
                          className="
          text-xs 
          text-gray-500 
          mt-1
          leading-relaxed
        "
                        >
                          Please confirm that you have reviewed and verified all
                          provided information before approving this request.
                        </p>
                      </div>
                    </div>

                    {/* Checkbox Confirmation */}
                    <label
                      className={`
        flex 
        items-start 
        gap-3 
        p-4 
        rounded-xl
        border
        cursor-pointer
        transition-all
        duration-200

        ${
          verificationConfirmed
            ? 'bg-green-50 border-green-300'
            : 'bg-gray-50 border-gray-200 hover:border-gray-300'
        }
      `}
                    >
                      <input
                        type="checkbox"
                        checked={verificationConfirmed}
                        onChange={(e) =>
                          setVerificationConfirmed(e.target.checked)
                        }
                        className="
          mt-1
          w-5
          h-5
          rounded
          accent-green-600
          cursor-pointer
        "
                      />

                      <div className="flex-1">
                        <p
                          className="
          text-sm
          font-medium
          text-gray-800
        "
                        >
                          I have verified the information
                        </p>

                        <p
                          className="
          text-xs
          text-gray-500
          mt-1 whitespace-normal break-words
        "
                        >
                          I confirm that the details, documents, and supporting
                          information have been reviewed and validated.
                        </p>
                      </div>
                    </label>

                    {/* Reviewer Info + Action */}
                    <div
                      className="
      flex
      flex-col
      sm:flex-row
      sm:items-center
      sm:justify-between
      gap-4
      pt-4
      border-t
    "
                    >
                      {/* Timestamp */}
                      <div>
                        <p
                          className="
          text-[11px]
          uppercase
          tracking-wide
          text-gray-400
        "
                        >
                          Review Time
                        </p>

                        <p
                          className="
          text-sm
          font-medium
          text-gray-700
          mt-1
        "
                        >
                          {currentDateTime}
                        </p>
                      </div>

                      {/* Action Button */}
                      <button
                        onClick={(e) => {
                          if (!verificationConfirmed) {
                            showToast(
                              'Please confirm the verification before approval',
                              'error',
                            );

                            return;
                          }

                          setLoading(true);
                          handlSendComment(e, 'approve');
                        }}
                        disabled={!verificationConfirmed}
                        className={`
          w-full
          sm:w-auto

          px-8
          py-3

          rounded-xl

          text-sm
          font-semibold

          transition-all
          duration-200

          ${
            verificationConfirmed
              ? 'bg-gradient-to-r from-[#375AE7] to-[#5B7CFF] text-white shadow-md hover:shadow-lg hover:-translate-y-[1px]'
              : 'bg-gray-200 text-gray-400 cursor-not-allowed'
          }

        `}
                      >
                        Confirm Approval
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {isModalOpen && currentDocument && (
        <DocumentPreview
          fileUrl={currentDocument.presigned_url}
          fileName={currentDocument.file_name}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </div>
  );
};
export default ReviewPopupKYC;
